// extracted by mini-css-extract-plugin
export default {"header":"BoldTextHeader_header__bfJax"};